import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/pt-br';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import cacheManager from '../CacheManager';
import 'bootstrap/dist/css/bootstrap.min.css';

moment.locale('pt-br'); // Configura o moment para usar o idioma português

const localizer = momentLocalizer(moment);

const messages = {
    allDay: 'Dia inteiro',
    previous: 'Anterior',
    next: 'Próximo',
    today: 'Hoje',
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    agenda: 'Agenda',
    date: 'Data',
    time: 'Hora',
    event: 'Evento',
    noEventsInRange: 'Não há eventos neste intervalo.',
    showMore: total => `+ Ver mais (${total})`
};

// Componente customizado para os dias da semana
const CustomDay = ({ label }) => {
    const isSunday = label === 'Dom';
    return (
        <div style={{ color: isSunday ? 'gray' : 'inherit' }}>
            {label}
        </div>
    );
};

const PgAgenda = () => {
    const [events, setEvents] = useState([]);
    const [filteredAgendamentos, setFilteredAgendamentos] = useState([]);
    const [selectedEspaco, setSelectedEspaco] = useState('All');
    const [itensById, setItensById] = useState({});

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const data = await cacheManager.getAgendamentosCache();
                const itensById = await cacheManager.getItensById();
                setItensById(itensById);
                let eightMonthsAgo = new Date();
                const currentMonth = eightMonthsAgo.getMonth();
                const targetMonth = currentMonth - 8;

                // Ajuste para lidar com a virada do ano
                if (targetMonth < 0) {
                    eightMonthsAgo.setFullYear(eightMonthsAgo.getFullYear() - 1);
                    eightMonthsAgo.setMonth(12 + targetMonth);
                } else {
                    eightMonthsAgo.setMonth(targetMonth);
                }

                const formattedEvents = data
                    .filter(agendamento => ((new Date(agendamento.data_inicio_agendamento)) >= eightMonthsAgo))
                    .map(agendamento => ({
                        title: '['+agendamento.id_agendamento +'] '+ itensById[agendamento.id_item].titulo,
                        start: new Date(agendamento.data_inicio_agendamento),
                        end: new Date(agendamento.data_fim_agendamento),
                        id_item: agendamento.id_item,
                    }));
                setEvents(formattedEvents);
                setFilteredAgendamentos(formattedEvents); // Inicialmente, sem filtro
            } catch (error) {
                console.error('Erro ao buscar agendamentos:', error);
            }
        };

        fetchEvents();
    }, []);

    useEffect(() => {
        if (selectedEspaco === 'All') {
            setFilteredAgendamentos(events);
        } else if (selectedEspaco === '8') {
            setFilteredAgendamentos(events.filter(event => ['8', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32'].includes(itensById[event.id_item].id_espaco)));
        } else {
            setFilteredAgendamentos(events.filter(event => itensById[event.id_item].id_espaco === selectedEspaco));
        }
    }, [selectedEspaco, events, itensById]);

    return (
        <div className="container mt-5">
            <h1>Agenda</h1>
            
            <div className="btn-group mb-3" role="group" aria-label="Filtro por Espaço">
                <input type="radio" className="btn-check" name="btnradio" id="btnradioAll" autoComplete="off" value="All" checked={selectedEspaco === 'All'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradioAll">Todos</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio4" autoComplete="off" value="4" checked={selectedEspaco === '4'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio4">Salão Jatiúca</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio5" autoComplete="off" value="5" checked={selectedEspaco === '5'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio5">Salão Murici</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio6" autoComplete="off" value="6" checked={selectedEspaco === '6'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio6">Sala 1</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio7" autoComplete="off" value="7" checked={selectedEspaco === '7'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio7">Sala 2</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio8" autoComplete="off" value="8" checked={selectedEspaco === '8'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio8">Estação individual de trabalho</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio33" autoComplete="off" value="33" checked={selectedEspaco === '33'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio33">Sala 3</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio34" autoComplete="off" value="34" checked={selectedEspaco === '34'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio34">Sala 4</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio35" autoComplete="off" value="35" checked={selectedEspaco === '35'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio35">Sala 2 + Procedimentos</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio37" autoComplete="off" value="37" checked={selectedEspaco === '37'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio37">SALA 303 - FAESTAL</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio38" autoComplete="off" value="38" checked={selectedEspaco === '38'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio38">Sala 3 + Procedimentos</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio39" autoComplete="off" value="39" checked={selectedEspaco === '39'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio39">SALA 109 - FAESTAL</label>

                <input type="radio" className="btn-check" name="btnradio" id="btnradio40" autoComplete="off" value="40" checked={selectedEspaco === '40'} onChange={(e) => setSelectedEspaco(e.target.value)} />
                <label className="btn btn-outline-primary" htmlFor="btnradio40">Salão Jatiúca (20 lugares)</label>
            </div>

            <Calendar
                localizer={localizer}
                events={filteredAgendamentos}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
                messages={messages}
                formats={{
                    dateFormat: 'DD/MM/YYYY',
                    dayFormat: (date, culture, localizer) =>
                        localizer.format(date, 'ddd, DD/MM/YYYY', culture),
                    weekdayFormat: (date, culture, localizer) =>
                        localizer.format(date, 'ddd', culture),
                }}
                components={{
                    day: CustomDay,
                }}
                min={new Date(1970, 1, 1, 7, 0, 0)}
                max={new Date(1970, 1, 1, 20, 0, 0)}
            />
        </div>
    );
};

export default PgAgenda;